import { render, staticRenderFns } from "./CreateInvoiceRecord.vue?vue&type=template&id=4bf626e3"
import script from "./CreateInvoiceRecord.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports